<div class="col-md-8 offset-md-2 col-sm-8 offset-sm-2">
  <div class="row row-cols-1 row-cols-lg-3 d-flex justify-content-center">
    <!--identibase+-->
    <div class="col my-5 text-center identibaseplus-price-card-wrapper" *appFeatureFlag="'isIdentiPlusAvailable'">
      <app-price-card
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="identibasePlusButtonLabel"
        [hidePrices]="true"
        [showButton]="(buyButtonVisible || (!buyButtonVisible && !basicPlusHighlighted))"
        [disabled]="buyButtonDisabled && !!findHighlighted"
        (onSelect)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentibasePlusButton)
        "
        [highlighted]="basicPlusHighlighted"
        imageUri="/assets/images/pricingTable/identibasePlus.svg"
        planTitle="{{ plan1Name }}"
        planLongSubtitle="For less than {{ plan1DailyPrice }} per day, activate your pet’s Digital ID with:"
        [hidePlusFromSubtitle]="true"
        [features]="getFeaturesFor(planFeatureService.plan1Name)"
        yearlyPrice="{{ plan1YearlyPrice }}"
        description="Get your missing pet home more quickly by activating your pet’s
      Digital ID. And, with identibase+, keep the Digital ID up to date with
      unlimited changes to your details."
        [showBestSeller]="false"
      >
      </app-price-card>
    </div>

    <!--Identialert-->
    <div class="col mb-5 text-center" *appFeatureFlag="'isIdentialertAvailable'">
      <app-price-card
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="identialertButtonLabel"
        [hidePrices]="true"
        [hidePlusFromSubtitle]="isBrandPetlog"
        [showButton]="(buyButtonVisible || (!buyButtonVisible && !alertHighlighted))"
        [disabled]="buyButtonDisabled && !!findHighlighted"
        (onSelect)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentialertButton)
        "
        [highlighted]="alertHighlighted"
        [showBestSeller]="false"
        [features]="getFeaturesFor(planFeatureService.plan2Name)"
        imageUri="/assets/images/pricingTable/identialert.svg"
        planTitle="{{ plan2Name }}"
        planShortSubtitle="Everything from {{ plan1Name }}"
        planLongSubtitle="For less than {{ plan2DailyPrice }} per day, get everything from {{ plan1Name }}"
        yearlyPrice="{{ plan2YearlyPrice }}"
        monthlyPrice="{{ plan2MonthlyPrice }}"
        priceNote="(12 month contract)"
        description="The fastest way to find your missing pet. A 24/7 network of pet finders - with alerts sent to every vet, warden, rescue centre, police and {{ brandName }} customers in your area."
      >
      </app-price-card>
    </div>
  </div>
</div>
